/**
 * Forms
 *
 * @package Globus
 * @since   1.0.0
 */
/* eslint no-undef: 0 */
import $ from 'jquery';
import 'jquery-uniform';
import * as helpers from '../global/helpers';
import { els } from './variables';

/**
 * Run .uniform() on file upload fields and wrap select elements
 * in a parent container for easier styling.
 *
 * @since  1.0.0
 */
function initPrettyForms() {
	/**
	 * Run uniform on upload elements only.
	 */
	if ($('[type="file"]').length) {
		$('[type="file"]').each(
			function () {
				const $this = $(this);

				/**
				 * If .uploader is not the parent, add it.
				 */
				if (!$this.parent().hasClass('uploader')) {
					const classes = $(this).attr('class');
					$this.uniform();
					$this.removeClass(classes).parents('.uploader').addClass(classes);
				}

				/**
				 * Fixes issue on Windows Chrome where 'ginput_container_fileupload' class is not being appended
				 */
				$this.closest('.ginput_container').addClass('ginput_container_fileupload');
			},
		);
	}

	if ($('.datepicker').length) {
		$('.datepicker').attr('autocomplete', 'off');
	}

	/**
	 * Fixes weird bug in iOS where long options get ellipsis.
	 *
	 * @see https://stackoverflow.com/questions/19398154/how-to-fix-truncated-text-on-select-element-on-ios7
	 */
	// $('select').append('<optgroup label=""></optgroup>');
}

/**
 * Scroll to gravity forms errors.
 *
 * @since  1.0.0
 */
function scrollToFormErrors() {
	const formsWithErrors = document.querySelectorAll('.gform_validation_error');
	if (formsWithErrors.length > 0) {
		window.addEventListener('load', () => {
			const timeout = document.body.classList.contains('ios') || document.body.classList.contains('android') ? 1000 : 200;
			setTimeout(() => {
				helpers.scrollToEl($(formsWithErrors[0]), els.header.offsetHeight);
			}, timeout);
		});
	}
}

document.addEventListener('DOMContentLoaded', initPrettyForms);
document.addEventListener('DOMContentLoaded', scrollToFormErrors);
// ! Re-run Uniform functions on gravity forms reloads (without page refresh).
$(document).on('gform_post_render', initPrettyForms);

function ListFieldRowCount() {
	const listField = '#field_11_108';
	const Rows = jQuery(listField).find('table.gfield_list tbody tr');
	let i;
	for (i = 1; i < Rows.length; i++) {
		const tag = Rows[i].getElementsByTagName('label')[0];
		const label = `Rotation ${Number(i) + 1}`;
		tag.innerHTML = label;
	}
}
function ListFieldRowTotal() {
	ListFieldRowCount();
	const listField = '#field_11_108';
	jQuery(listField).on(
		'click',
		'.add_list_item',
		() => {
			ListFieldRowCount();
			jQuery(`${listField} .delete_list_item`).removeProp('onclick');
		},
	);
	jQuery(listField).on(
		'click',
		'.delete_list_item',
		function () {
			gformDeleteListItem(this, 0);
			ListFieldRowCount();
		},
	);
}

ListFieldRowCount();
ListFieldRowTotal();

$('input[type=file]').on('change', function () {
	if ($(this).val() !== '') {
		$(this).parent().addClass('after');
		$(this).parent().append('<span class="after-x"></div>');
	} else {
		$(this).parent().removeClass('after');
		$('.after-x').remove();
	}
});

$(document).on('click', '.after-x', function () {
	$('.filename').text('');
	$(this).parent().removeClass('after');
	$('.after-x').remove();
});

document.addEventListener('DOMContentLoaded', ListFieldRowCount);
